// src/presentation/pages/ClinicalExamination/sections/ExecutiveFunctionSection.tsx
import React from "react";
import { CardTitle } from "@/components/ui/card";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { useTranslation } from "react-i18next";
import { booleanRadioValue } from "../types";

interface ExecutiveFunctionSectionProps {
  difficultyPlanning: boolean | null;
  difficultyManagingFinances: boolean | null;
  onDifficultyPlanningChange: (value: boolean) => void;
  onDifficultyManagingFinancesChange: (value: boolean) => void;
}

export const ExecutiveFunctionSection: React.FC<
  ExecutiveFunctionSectionProps
> = ({
  difficultyPlanning,
  difficultyManagingFinances,
  onDifficultyPlanningChange,
  onDifficultyManagingFinancesChange,
}) => {
  const { t } = useTranslation("patients");
  return (
    <div className=" border-gray-200">
      <div className="pb-3">
        <CardTitle className="text-base font-semibold text-gray-900">
          {t("clinicalSections.executiveFunction.title")}
        </CardTitle>
      </div>
      <div className="space-y-6">
        {/* Difficulty Planning */}
        <div>
          <p className="text-sm text-gray-700 mb-3">
            {t("clinicalSections.executiveFunction.planningQuestion")}
          </p>
          <RadioGroup
            value={booleanRadioValue(difficultyPlanning)}
            onValueChange={(val) => onDifficultyPlanningChange(val === "true")}
            className="flex gap-6"
          >
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="true" id="planning-yes" />
              <Label
                htmlFor="planning-yes"
                className="text-[#1B1D21] cursor-pointer text-sm font-normal"
              >
                {t("clinicalSections.yes")}
              </Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="false" id="planning-no" />
              <Label
                htmlFor="planning-no"
                className="text-[#1B1D21] cursor-pointer text-sm font-normal"
              >
                {t("clinicalSections.no")}
              </Label>
            </div>
          </RadioGroup>
        </div>

        {/* Difficulty Managing Finances */}
        <div>
          <p className="text-sm text-gray-700 mb-3">
            {t("clinicalSections.executiveFunction.financesQuestion")}
          </p>
          <RadioGroup
            value={booleanRadioValue(difficultyManagingFinances)}
            onValueChange={(val) =>
              onDifficultyManagingFinancesChange(val === "true")
            }
            className="flex gap-6"
          >
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="true" id="finances-yes" />
              <Label
                htmlFor="finances-yes"
                className="text-[#1B1D21] cursor-pointer text-sm font-normal"
              >
                {t("clinicalSections.yes")}
              </Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="false" id="finances-no" />
              <Label
                htmlFor="finances-no"
                className="text-[#1B1D21] cursor-pointer text-sm font-normal"
              >
                {t("clinicalSections.no")}
              </Label>
            </div>
          </RadioGroup>
        </div>
      </div>
    </div>
  );
};
